import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListCompanies, CompanyElement, CompanyElementResponse } from '../models/company.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root'
})

export class CompanyService {

  public lstCompanies: ListCompanies[] = [];

  constructor(private http: HttpClient) { }

  item: any = [];
  items: any = [];



  getAllCompanies(): Observable<CompanyElementResponse> {
    const API_URL_COMP =  `${API_URL}/companies`;
    return this.http.get<CompanyElementResponse>(`${API_URL_COMP}`);
  }

  getCompanyById(id: number):Observable<CompanyElement> {
    const API_URL_COMP = `${API_URL}/companies/${id}`;
    return this.http.get<CompanyElement>(`${API_URL_COMP}`);
  }

  addCompany(company: CompanyElement):Observable<any>  {
    const API_URL_COMP = `${API_URL}/companies`;
    return this.http.post(`${API_URL_COMP}`, company);
  }

  updateCompany(id: number, company: CompanyElement):Observable<any>  {
    const API_URL_COMP = `${API_URL}/companies/${id}`;
    return this.http.put(`${API_URL_COMP}`, company);
  }

  deleteCompany(id: number):Observable<any>  {
    const API_URL_COMP = `${API_URL}/companies/${id}`;
    return this.http.delete(`${API_URL_COMP}`);
  }

  getCompaniesListByRol(role_id: number, company_id: number):ListCompanies[] {
    this.lstCompanies=[];

    if(role_id == 1){
      //admin
      const req = this.getAllCompanies();
      req.subscribe({
        next: (res) => {
          this.items = res;
          if(this.items.data != null){
            for (let itm of this.items.data ){
              this.lstCompanies.push( {value: itm.id, viewValue: itm.name} );
            }
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });

    }else{
      //no admin
      const req = this.getCompanyById(company_id);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.lstCompanies.push( {value: company_id, viewValue: this.item.data.name} );
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });
    }
    return this.lstCompanies;
  }

}
